import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import { detailsGdd, preLink } from "./styles/detailsGdd.module.scss"
import {
  titleGdd,
  homeLogo,
  imgLogo,
  backContainer,
  backToSite,
  backLink,
} from "../list/styles/listGdd.module.scss"
import PropTypes from "prop-types"
import { StyledSection, BandeauStyled } from "./styled-components/gdd-styled"
import { useBuildData } from "../../hooks/use-build-data"
import Icon from "../../components/Icon/icon"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import ImageFromDrupal from "../../components/Image/image-from-drupal"
import ReactHtmlParser, { processNodes } from "react-html-parser"
import TransitionFade from "../../components/transition-fade"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query($slug: String!) {
    asciidoc(path: { alias: { eq: $slug } }) {
      html
      document {
        title
      }
    }
  }
`
//-----------------------QueryGraphql---------------------------//

const HtmlParser = ({ content }) => {
  return new ReactHtmlParser(content, {
    transform: function transform(node, elementIndex) {
      if (
        node.type === "tag" &&
        node.name === "div" &&
        !node.parent &&
        (node.attribs.class === "paragraph" || node.attribs.class === "sect1")
      ) {
        return (
          <StyledSection key={elementIndex} className={detailsGdd}>
            {processNodes(node.children, transform)}
          </StyledSection>
        )
      }
      if (node.type === "tag" && node.name === "a") {
        const internalLinkRegex = /\/Particuliers\//
        if (internalLinkRegex.test(node.attribs.href)) {
          return (
            <TransitionFade key={elementIndex} link={node.attribs.href}>
              {processNodes(node.children, transform)}
            </TransitionFade>
          )
        }
        return (
          <a
            key={elementIndex}
            target="_blank"
            rel="noopener noreferrer"
            href={node.attribs.href}
          >
            {processNodes(node.children, transform)}
          </a>
        )
      }
      if (node.type === "tag" && node.name === "pre") {
        // check if string contains link to separate link and text
        const regex = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm // eslint-disable-line
        let url = []
        if (regex.test(node.children[0]?.data)) {
          url = node.children[0]?.data.match(regex)
        }
        if (url.length > 0) {
          url.map((element) => {
            node.children[0].data = node.children[0]?.data.replace(element, "")
            return null
          })
        }
        return (
          <React.Fragment key={elementIndex}>
            {url.map((element, index) => {
              const internalLinkRegex = /\/Particuliers\//
              if (internalLinkRegex.test(element)) {
                return (
                  <TransitionFade
                    className={preLink}
                    key={index}
                    link={element}
                  >
                    {element}
                  </TransitionFade>
                )
              }
              return (
                <a
                  key={elementIndex}
                  className={preLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={element}
                >
                  {element}
                </a>
              )
            })}
            <p>{processNodes(node.children, transform)}</p>
          </React.Fragment>
        )
      }
    },
  })
}

//-----------------------Component---------------------------//

const GddTemplate = ({ data }) => {
  const buildColors = useBuildData().theme_settings.palette
  const buildInfos = useBuildData().site_settings
  return (
    <Layout isGdd={true} isDetail={true}>
      <SEO
        title={data.asciidoc.document.title}
        description={data.asciidoc.document.title}
      />
      <div className="headerGDD">
        <AniLink
          aria-label="Logo d'accueil"
          className={backLink}
          paintDrip
          hex={buildColors.a_color_gradients.a_dark}
          to="/"
        >
          {buildInfos.website_logo.fid === null ? (
            <div className={backContainer}>
              <Icon className={homeLogo} size={24} icon="home" />
              <p className={backToSite}>Retour au site</p>
            </div>
          ) : (
            <ImageFromDrupal
              className={imgLogo}
              alt={"Logo " + buildInfos.website_name}
              drupal_fid={buildInfos.website_logo.fid}
            />
          )}
        </AniLink>
        <h1 className={titleGdd}>
          GUIDE<br></br>« VOS DROITS ET DÉMARCHES »<br></br>POUR LES
          PARTICULIERS
        </h1>
        <BandeauStyled />
      </div>
      <HtmlParser content={data.asciidoc.html} />
    </Layout>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

GddTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default GddTemplate
